<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img
                            class="part-one-title-img"
                            src="../assets/imgs/craft/part-1-title.png"
                            alt=""
                        />
                        <div class="part-text part-one-text">
                            为鼓励企业引进和培育急需紧缺专业技术人才，按照“人才新政12条”“人才新政3.0版”，对企业新引进、符合条件的急需紧缺专业技术人才发放安家补贴。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-two">
                <img
                    src="../assets/imgs/craft/part-2-title.png"
                    class="part-two-title-img"
                />
                <div
                    class="part-title part-two-title"
                    style="margin-top: 1.44rem"
                >
                    需同时满足以下条件：
                </div>
                <div class="part-two-content">
                    <div
                        v-for="item in part2"
                        :key="item.id"
                        style="margin-bottom: 0.22rem; position: relative"
                    >
                        <div class="part-two-dot">{{ item.id }}</div>
                        {{ item.text }}
                    </div>
                    <div style="color: #3d5aa3">
                        注：《成都市人才开发指引(人才白皮书)》，拟于每年4月发布。
                    </div>
                </div>
            </div>
            <div class="part-three">
                <img
                    src="../assets/imgs/craft/part-3-title.png"
                    class="part-two-title-img"
                />
                <div
                    class="part-three-items part-text"
                    v-for="item in part3"
                    :key="item.id"
                    :style="item.boxHeight"
                >
                    {{ item.text }}
                </div>
            </div>
            <div class="part-four">
                <img
                    src="../assets/imgs/craft/part-4-title.png"
                    class="part-two-title-img"
                />
                <div class="main-content">
                    <div
                        class="part-four-items"
                        v-for="item in part4"
                        :key="item.id"
                        :style="item.boxHeight"
                    >
                        <div :class="item.title">{{ item.label }}</div>
                        <div class="part-four-content1">
                            <span
                                class="inside-title"
                                v-if="item.content1.title"
                                >{{ item.content1.title }}</span
                            >
                            {{ item.content1.text }}
                        </div>
                        <div class="part-four-content2" v-if="item.content2">
                            <div
                                v-for="(item2, index2) in item.content2"
                                :key="index2"
                            >
                                {{ item2 }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="contact">
                <img
                    class="top"
                    src="./../assets/imgs/Relocationallowance/label4.png"
                    alt=""
                />
                <div class="content">按照每年度通知时间确定。</div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                <div class="content">
                    <div class="number">
                        <span class="label">政策咨询电话：</span>
                        <div>
                            <a href="tel:028-61888121">028-61888121</a>
                        </div>
                    </div>
                    <div class="unit">
                        <span class="label">责任单位：</span>
                        成都市人力资源和社会保障局专业技术人员服务管理处
                    </div>
                </div>
            </div>
            <div class="part-five">
                <img
                    src="../assets/imgs/Relocationallowance/code1.png"
                    style="width: 1.94rem; height: 1.94rem"
                />
                <img
                    src="../assets/imgs/Relocationallowance/info.png"
                    style="
                        width: 6.42em;
                        height: 1.94rem;
                        position: absolute;
                        top: 0.35rem;
                        left: 0.35rem;
                    "
                    alt=""
                />
            </div>
        </div>
        <call phone="028-61888121"></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";

export default {
    name: "craft",
    data() {
        return {
            part2: [
                {
                    id: 1,
                    text: "在本市各级市场监督管理部门依法登记、具有独立法人资格，纳税关系在本市，属于我市重点产业链“链主企业”及上下游重点产业企业（以下简称重点企业）新引进的专业技术人才；",
                },
                {
                    id: 2,
                    text: "从本市行政区域外引进到重点企业工作，并与其签订3年及以上劳动合同或聘用合同（合同签订单位须与社保缴纳单位名称一致)；",
                },
                {
                    id: 3,
                    text: "人才符合《成都市企业引进急需紧缺专业技术人才补贴目录》l、Ⅱ、Ⅲ、Ⅳ四类条件之一，或符合引进当年《成都市人才开发指引(人才白皮书)》中紧缺指数3星岗位要求的专业技术人才。",
                },
            ],
            part3: [
                {
                    id: 1,
                    boxHeight: "",
                    text: "（一）符合《成都市企业引进急需紧缺专业技术人才补贴目录》l、II、III类条件之一的人才，从引进的次月起3年内，给予3000元/人·月的安家补贴。",
                },
                {
                    id: 2,
                    boxHeight: "",
                    text: "（二）符合《成都市企业引进急需紧缺专业技术人才补贴目录》Ⅳ类条件之一，或符合《成都市人才开发指引（成都人才白皮书）》中紧缺度3星岗位要求的人才，从引进的次月起3年内，给予2000元/人·月的安家补贴。",
                },
            ],
            part4: [
                {
                    id: 11,
                    title: "title-bg",
                    label: "集中申报",
                    content1: {
                        title: "",
                        text: "市人社局根据年度计划印发文件，高技能人才所在企业向注册地人社部门提出申请。提交以下材料：",
                    },
                    content2: [
                        "1．成都市引进急需紧缺高技能人才安家补贴申请表；",
                        "2．企业营业执照、完税证明的原件及复印件；",
                        "3．引进人才的身份证、职业资格证书、职业成就认定材料、劳动合同或工作协议的原件及复印件。"
                    ],
                    boxHeight: "",
                },
                {
                    id: 21,
                    label: "区（市）县初审推荐",
                    title: "title-bg title-bg2",
                    content1: {
                        title: "",
                        text: "",
                    },
                    content2: "",
                    boxHeight: "",
                },
                {
                    id: 31,
                    label: "市人社局复核",
                    title: "title-bg title-bg3",
                    content1: {
                        title: "",
                        text: "",
                    },
                    content2: "",
                    boxHeight: "",
                },
                {
                    id: 41,
                    label: "公示确认",
                    title: "title-bg title-bg4",
                    content1: {
                        title: "",
                        text: "",
                    },
                    content2: "",
                    boxHeight: "border:none",
                },
            ],
        };
    },
    components: {
        // bottom,
        call,
    },
    created() {},
    mounted() {},
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .part-title {
        font-size: 0.34rem;
        //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        height: 7.1rem;
        width: 7.5rem;
        // margin-left: 0.02rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            height: 5.6rem;
            background: url(../assets/imgs/Relocationallowance/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                padding-bottom: 0.35rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: 0;
                    width: 6.86rem;
                    height: 1.12rem;
                }

                .part-one-text {
                    margin-top: 1.2rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.18rem;
        position: absolute;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #e8eeff;
        border-radius: 10px;
        padding-left: 0.33rem;
        padding-right: 0.3rem;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        box-sizing: border-box;
        position: relative;

        .part-two-title {
            text-align: left;
            margin-left: 0.33rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.35rem;
            }
        }

        .part-two-content {
            margin-top: 0.2rem;
            margin-bottom: 0.3rem;
            width: 6.22rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 0.34rem 0.24rem 0.35rem 0.67rem;
            font-size: 0.26rem;
            //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            line-height: 0.44rem;
            text-align: left;

            .part-two-dot {
                position: absolute;
                top: 0;
                left: -0.46rem;
                width: 0.36rem;
                height: 0.36rem;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 0.26rem;
                background: #739bfe;
                border-radius: 50%;
            }
        }
    }

    .part-three {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.84rem 0.25rem 0.25rem 0.25rem;

        .part-three-items {
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            padding: 0.31rem;
            box-sizing: border-box;
            position: relative;
            margin-bottom: 0.22rem;
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        display: inline-block;
        position: relative;
        padding: 1.44rem 0.25rem 0 0.25rem;

        .main-content {
            margin-top: 0.34rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.8rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;

            .part-four-items {
                box-sizing: border-box;
                border-left: 0.02rem dashed #739bfe;
                margin-bottom: 0.6rem;
                padding-left: 0.33rem;
                padding-top: 0.2rem;
                position: relative;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
                padding-bottom: 0.35rem;

                .title-bg {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.34rem;
                    //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    background: url(../assets/imgs/craft/part4-1.png);
                    background-size: 100% 100%;
                }

                .title-bg2 {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.34rem;
                    //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    background: url(../assets/imgs/craft/part4-2.png);
                    background-size: 100% 100%;
                    // width: 5rem;
                    // height: 0.6rem;
                    // background: url(../assets/imgs/craft/part4-2.png);
                    // background-size: 100% 100%;
                }

                .title-bg3 {
                    width: 5rem;
                    height: 0.6rem;
                    background: url(../assets/imgs/Relocationallowance/part4-3.png);
                    background-size: 100% 100%;
                }

                .title-bg4 {
                    background: url(../assets/imgs/craft/part4-4.png);
                    background-size: 100% 100%;
                }

                .inside-title {
                    font-weight: 800;
                }

                .part-four-content2 {
                    font-weight: bolder;
                }
            }
        }
    }

    .part-five {
        width: 6.85rem;
        background: #fff;
        margin: 0 auto;
        margin-top: 0.32rem;
        border-radius: 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        padding: 0.35rem;
        position: relative;
        .code-box {
            flex: 1;
            display: inline-flex;
            justify-content: center;
            align-items: center;
        }
    }

    .bottom-info {
        margin-top: 0.22rem;
        font-size: 0.24rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #97a9d9;

        a {
            text-decoration: none;
            // color: #97a9d9;
        }
    }
}
</style>
